import React, { useState } from 'react';
import { SparklesIcon, UsersIcon } from 'lucide-react';
import { genreColors, formatIcons } from './constants';
import { BookHoverCard } from './BookHoverCard';
import { VendorBookInfoModal, CoverCarousel } from './BookDisplay';
export const CoWriteBooksView = ({
  selectedCoAuthor,
  viewMode,
  darkMode,
  booksByType,
  filteredCoWriteBooks,
  hoveredBookId,
  setHoveredBookId,
  mousePosition,
  navigateToBookEdit
}: any) => {
  const [selectedBook, setSelectedBook] = useState<any | null>(null);
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  const handleSpineTap = (book: any) => {
    if (window.innerWidth < 768) {
      setSelectedBook(book);
    } else {
      navigateToBookEdit(book.id);
    }
  };
  const SpineBook = ({
    book
  }: {
    book: any;
  }) => <div onClick={() => handleSpineTap(book)} onMouseEnter={() => !isMobile && setHoveredBookId(book.id)} onMouseLeave={() => setHoveredBookId(null)} className="relative flex flex-col items-center justify-center text-white font-medium rounded transition-transform duration-200 ease-in-out cursor-pointer text-center hover:scale-105 select-none flex-shrink-0" style={{
    width: book.edition === 'special' ? 68 : 56,
    height: book.edition === 'special' ? 250 : 220,
    fontSize: book.edition === 'special' ? '1rem' : '0.85rem',
    backgroundColor: genreColors[!book.coverImage ? book.genre : ''] || genreColors.default,
    backgroundImage: book.coverImage ? `url(${book.coverImage})` : undefined,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    marginBottom: 4
  }} title={`${book.title} (with ${book.coAuthor})`} data-id="element-18045" data-mp="1frn8zisat552">
      {!book.coverImage && <div className="flex flex-col items-center px-1 w-full h-full justify-center" style={{
      writingMode: 'vertical-rl'
    }} data-id="element-18046" data-mp="3gwvb8zhnn8yv">
          <div className="w-full truncate" data-id="element-18047" data-mp="3kfawby8t3qui">{book.title}</div>
        </div>}
      <div className="absolute bottom-1 left-1 inline-flex items-center justify-center p-1 rounded bg-black bg-opacity-70 text-white text-xs z-10" title={book.format} data-id="element-18048" data-mp="3kd7vej648db0">
        {formatIcons[book.format]}
      </div>
      {book.edition === 'special' && <div className="absolute top-1 right-1 inline-flex items-center justify-center p-1 rounded-full bg-purple-600 bg-opacity-90 text-white text-xs z-10" data-id="element-18049" data-mp="35jl61nwl8rjz">
          <SparklesIcon className="h-3 w-3" data-id="element-18050" data-mp="20rx5oer8qw5" />
        </div>}
    </div>;
  const activeBooks = selectedCoAuthor === 'all' ? booksByType.cowrite : filteredCoWriteBooks;
  const title = selectedCoAuthor === 'all' ? 'All Co-written Books' : `With ${selectedCoAuthor}`;
  // Use carousel when filtered to a specific co-author (ordered group), grid for "all"
  const useCarousel = selectedCoAuthor !== 'all';
  return <>
      <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow-md p-6 mb-8`} data-id="element-18051" data-mp="kyuqugi8zc0a">
        <h2 className={`text-xl font-semibold mb-6 ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-18052" data-mp="tawbq6ugs3ab">
          {title}
        </h2>

        {viewMode === 'spine' ? <div className="relative" data-id="element-18053" data-mp="1286qi26hqajz">
            <div className="flex items-end gap-2 overflow-x-auto pb-6 scrollbar-thin" style={{
          minHeight: 260
        }} data-id="element-18054" data-mp="178ba412p3lef">
              {activeBooks.map((book: any) => <SpineBook key={book.id} book={book} data-id="element-18055" data-mp="1g7yaqknlon6f" />)}
              <div className={`absolute bottom-0 left-0 right-0 h-2 ${darkMode ? 'bg-purple-900' : 'bg-purple-600'} rounded-full`} data-id="element-18056" data-mp="1kzhfuewkif9r" />
            </div>
            {/* Hover card — desktop only */}
            {!isMobile && hoveredBookId && activeBooks.some((b: any) => b.id === hoveredBookId) && <BookHoverCard book={activeBooks.find((b: any) => b.id === hoveredBookId)} darkMode={darkMode} mousePosition={mousePosition} data-id="element-18057" data-mp="1zv5rgp47u4no" />}
          </div> : useCarousel /* Specific co-author — carousel (ordered group) */ ? <CoverCarousel books={activeBooks} darkMode={darkMode} onBookClick={book => setSelectedBook(book)} onHoverEnter={id => !isMobile && setHoveredBookId(id)} onHoverLeave={() => setHoveredBookId(null)} data-id="element-18058" data-mp="31fdea9y4dfb7" /> /* All co-writes — grid (mixed authors, no natural order) */ : <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-6" data-id="element-18059" data-mp="2ms0qsfor4zi6">
            {activeBooks.map((book: any) => <div key={book.id} className="relative flex flex-col items-center cursor-pointer group" onClick={() => setSelectedBook(book)} onMouseEnter={() => !isMobile && setHoveredBookId(book.id)} onMouseLeave={() => setHoveredBookId(null)} data-id="element-18060" data-mp="1zp6q9omraaf">
                <div className="relative w-full" data-id="element-18061" data-mp="aiturmh754t7">
                  <div className="w-full aspect-[2/3] bg-center bg-cover rounded-lg shadow-md transition-transform duration-200 ease-in-out group-hover:scale-[1.03] group-hover:shadow-xl" style={{
              backgroundImage: `url('${book.coverImage}')`
            }} title={book.title} data-id="element-18062" data-mp="3rpm9ivitq7pb" />
                </div>
              </div>)}
          </div>}
      </div>

      {activeBooks.length === 0 && <div className={`text-center py-12 ${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow-md`} data-id="element-18063" data-mp="jh5klma8nykl">
          <UsersIcon className={`h-12 w-12 ${darkMode ? 'text-gray-600' : 'text-gray-400'} mx-auto mb-4`} data-id="element-18064" data-mp="175yk1sq2kojy" />
          <h3 className={`text-lg font-medium mb-2 ${darkMode ? 'text-gray-200' : 'text-gray-900'}`} data-id="element-18065" data-mp="1c02skgezh4n5">
            No co-written books found
          </h3>
          <p className={darkMode ? 'text-gray-400' : 'text-gray-500'} data-id="element-18066" data-mp="1gvx150l1nu1r">
            Try adjusting your search or filters
          </p>
        </div>}

      {selectedBook && <VendorBookInfoModal book={selectedBook} darkMode={darkMode} onClose={() => setSelectedBook(null)} onEdit={navigateToBookEdit} data-id="element-18067" data-mp="17tntcih5ues2" />}
    </>;
};